module.exports = __webpack_public_path__ + "static/media/heaterlux-4.33aafdf6.jpg";